var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled from 'styled-components';
import { white } from '../colors';
import TopPanel from './top-panel';
import NavigationColumns from './navigation-columns';
import FooterBottom from './footer-bottom';
var FooterWrapper = styled.footer.withConfig({
  displayName: "footer__FooterWrapper",
  componentId: "sc-1oeyu0i-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), white());

var Footer = function Footer(_a) {
  var isLoading = _a.isLoading,
      content = _a.content,
      _b = _a.widgetActions,
      widgetActions = _b === void 0 ? {} : _b,
      _c = _a.linkComponent,
      linkComponent = _c === void 0 ? 'a' : _c,
      _d = _a.sitemapUrl,
      sitemapUrl = _d === void 0 ? '' : _d,
      _e = _a.sitemapLabel,
      sitemapLabel = _e === void 0 ? '' : _e;
  return /*#__PURE__*/React.createElement(FooterWrapper, {
    "data-test": 'footer'
  }, /*#__PURE__*/React.createElement(TopPanel, {
    topPanel: content === null || content === void 0 ? void 0 : content.topPanel,
    linkComponent: linkComponent,
    widgetActions: widgetActions,
    isLoading: isLoading
  }), /*#__PURE__*/React.createElement(NavigationColumns, {
    columns: content === null || content === void 0 ? void 0 : content.columns,
    linkComponent: linkComponent,
    isLoading: isLoading
  }), /*#__PURE__*/React.createElement(FooterBottom, {
    homeUrl: content === null || content === void 0 ? void 0 : content.homeUrl,
    logo: content === null || content === void 0 ? void 0 : content.logo,
    socialMediaLinks: content === null || content === void 0 ? void 0 : content.socialMediaLinks,
    bottomIcons: content === null || content === void 0 ? void 0 : content.bottomIcons,
    copyright: content === null || content === void 0 ? void 0 : content.copyright,
    linkComponent: linkComponent,
    isLoading: isLoading,
    sitemapUrl: sitemapUrl,
    sitemapLabel: sitemapLabel
  }));
};

export default Footer;
var templateObject_1;